import { useCountDown } from "ahooks";
import type { Options } from "ahooks/lib/useCountDown";

// 一天（毫秒）
const day = 24 * 3600 * 1000;

/**
 * 
 * @param countdown 毫秒
 * @param onTimeOut 
 * @returns 
 */
export function useRewardCountDown(props: Options) {
  const [countdown, { days, hours, minutes, seconds }] = useCountDown({
    interval: 1000,
    ...props,
  });

  const _seconds = seconds > 9 ? seconds : `0${seconds}`;
  const _minutes = minutes > 9 ? minutes : `0${minutes}`;
  const _hours = hours > 9 ? hours : `0${hours}`;

  const countdownStr = countdown ? (days ? `${days}d ${_hours}:${_minutes}:${_seconds}` : `${_hours}:${_minutes}:${_seconds}`) : undefined;
  return { countdownStr, formatRes: { days, hours, minutes, seconds }, isOverOneDay: countdown > day };
}